(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8922,7765],{

/***/ 65539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/idea/[id]/[slug]",
      function () {
        return __webpack_require__(73205);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/providers/source/SourceProvider.tsx + 1 modules
var SourceProvider = __webpack_require__(35396);
// EXTERNAL MODULE: ./src/components/collection/NewCollectionCarousel.tsx
var NewCollectionCarousel = __webpack_require__(11194);
// EXTERNAL MODULE: ./src/components/layout/Layout.tsx + 6 modules
var Layout = __webpack_require__(28146);
// EXTERNAL MODULE: ./src/components/metacontent/components/SubsectionHeader.tsx
var SubsectionHeader = __webpack_require__(17005);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/utils/strings/commonStrings.ts
var commonStrings = __webpack_require__(51599);
// EXTERNAL MODULE: ./src/page-components/source/components/CollectionInHeader.tsx
var CollectionInHeader = __webpack_require__(84803);
// EXTERNAL MODULE: ./src/providers/hooks/useSource.ts
var useSource = __webpack_require__(93361);
// EXTERNAL MODULE: ./src/components/cards/CuratorsNote.tsx
var CuratorsNote = __webpack_require__(53032);
// EXTERNAL MODULE: ./src/components/metacontent/sections/CuratorSection.tsx
var CuratorSection = __webpack_require__(13318);
// EXTERNAL MODULE: ./src/page-components/source/components/header/SourceTitleByType.tsx + 1 modules
var SourceTitleByType = __webpack_require__(71069);
// EXTERNAL MODULE: ./src/page-components/source/components/SourceCardVerticalProgress.tsx
var SourceCardVerticalProgress = __webpack_require__(65821);
;// CONCATENATED MODULE: ./src/page-components/source/components/IdeaPageMetacontent.tsx











var IdeaPageMetacontent = function() {
    var isDesktopView = (0,esm.useIsDesktopView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var source = (0,useSource/* default */.Z)().source;
    if (!source) return null;
    var curatorData = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: {
            base: "100%",
            md: (0,global/* getRemWidthFromColumns */._P)(4)
        },
        flexDirection: "column",
        children: [
            !isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                        mb: esm.spacing.XXS.rem,
                        children: commonStrings/* default.metacontent.curatedFrom */.Z.metacontent.curatedFrom
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceTitleByType/* default */.Z, {
                        source: source,
                        size: "md",
                        withLink: true,
                        m: 0,
                        numberOfLines: 5
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CuratorSection/* default */.Z, {
                mt: global/* GAP_SIZE_REM */.L3,
                user: source.userData
            }),
            source.context && /*#__PURE__*/ (0,jsx_runtime.jsx)(CuratorsNote/* default */.Z, {
                text: source.context,
                quoteColor: (0,global/* getTintHex */.As)({
                    ogColor: source.imageColor,
                    opacity: 0.5,
                    colorScheme: colorMode
                })
            })
        ]
    });
    return isDesktopView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        w: (0,global/* getRemWidthFromColumns */._P)(11),
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCardVerticalProgress/* default */.Z, {
                source: source
            }),
            curatorData
        ]
    }) : curatorData;
};
/* harmony default export */ var components_IdeaPageMetacontent = (IdeaPageMetacontent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/components/idea-card/IdeaCard.tsx + 4 modules
var IdeaCard = __webpack_require__(63848);
// EXTERNAL MODULE: ./src/components/layout/components/SectionTitle.tsx
var SectionTitle = __webpack_require__(57401);
;// CONCATENATED MODULE: ./src/page-components/source/components/SimilarIdeasList.tsx











var SimilarIdeasList = function(_param) {
    var originalIdeaTitle = _param.originalIdeaTitle, similarIdeas = _param.similarIdeas, props = (0,_object_without_properties/* default */.Z)(_param, [
        "originalIdeaTitle",
        "similarIdeas"
    ]);
    var isMobileView = (0,esm.useIsMobileView)();
    if (!similarIdeas || similarIdeas.length === 0) return null;
    var renderIdeaCard = function(idea) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            id: "".concat(idea.id),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IdeaCard/* default */.Z, {
                ideaData: {
                    idea: idea,
                    source: null
                },
                preloadImage: true,
                w: {
                    base: "100%",
                    md: (0,global/* getRemWidthFromColumns */._P)(6)
                },
                ml: {
                    base: 0,
                    md: (0,global/* getRemWidthFromColumns */._P)(1)
                },
                transition: "all 0.2s cubic-bezier(.43,.22,.05,.99)",
                zIndex: 1,
                minH: "auto",
                userSelect: "text",
                isNotInteractable: true
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        flexDirection: "column"
    }, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubsectionHeader/* default */.Z, {
                pt: {
                    base: global/* GAP_SIZE_REM */.L3,
                    md: global/* SECTION_GAP_REM */.hM
                },
                pb: global/* GAP_SIZE_REM */.L3,
                headingSize: "h3",
                children: [
                    commonStrings/* default.metacontent.similarSourcesSectionHeader */.Z.metacontent.similarSourcesSectionHeader,
                    originalIdeaTitle && " to ".concat(originalIdeaTitle)
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
                pt: global/* SECTION_GAP_REM */.hM,
                pb: esm.spacing.toRem(48),
                ml: (0,global/* getRemWidthFromColumns */._P)(1),
                title: commonStrings/* default.metacontent.similarSourcesSectionHeader */.Z.metacontent.similarSourcesSectionHeader + (originalIdeaTitle && " to ".concat(originalIdeaTitle))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flexDir: "column",
                w: "100%",
                position: "relative",
                gridGap: global/* GAP_SIZE_REM */.L3,
                pb: {
                    base: global/* GAP_SIZE_REM */.L3,
                    md: global/* SECTION_GAP_REM */.hM
                },
                children: similarIdeas.map(function(idea) {
                    return renderIdeaCard(idea);
                })
            })
        ]
    }));
};
/* harmony default export */ var components_SimilarIdeasList = (SimilarIdeasList);

// EXTERNAL MODULE: ./src/page-components/source/components/SourceCardIdeas.tsx
var SourceCardIdeas = __webpack_require__(24027);
// EXTERNAL MODULE: ./src/page-components/source/components/SourceSplashscreenBackground.tsx
var SourceSplashscreenBackground = __webpack_require__(1206);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./src/utils/metatopics.constants.ts
var metatopics_constants = __webpack_require__(90031);
;// CONCATENATED MODULE: ./src/page-components/source/IdeaPage.tsx






















var PrivateSourcePage = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1847).then(__webpack_require__.bind(__webpack_require__, 41847));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41847)
            ];
        }
    }
});
var IdeaPage = function(param) {
    var source = param.source, similarIdeas = param.similarIdeas, pageMetadata = param.pageMetadata, sectionBefore = param.sectionBefore;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var profile = (0,useProfile/* default */.Z)().profile;
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isOwnArticle = (profile === null || profile === void 0 ? void 0 : profile.id) === source.userData.id;
    var isDraft = source.status === enums/* ArticleStatus.DRAFT */.af.DRAFT;
    var firstIdea = source.ideas[0];
    if (isDraft && !isOwnArticle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            pageMetadata: pageMetadata,
            sections: [
                {
                    content: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivateSourcePage, {})
                }
            ]
        });
    }
    var sourceIdeasSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                            textTransform: "uppercase",
                            children: commonStrings/* default.ideaCuratedFrom */.Z.ideaCuratedFrom
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceTitleByType/* default */.Z, {
                            source: source,
                            size: "sm",
                            withLink: true,
                            mb: global/* GAP_SIZE_REM */.L3
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCardIdeas/* default */.Z, {})
            ]
        }),
        metaContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IdeaPageMetacontent, {}),
        metaContentTopOffset: 0,
        metaContentStickyOffset: global/* GAP_SIZE */.DG * 2,
        metaContentColumnStart: 0
    };
    var ref14, _title;
    var similarIdeasSection = {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            flexDirection: "column",
            width: "100%"
        }, isMobileView ? {
            mt: 16
        } : {
            mt: 48
        }), {
            children: [
                ((ref = source.seo) === null || ref === void 0 ? void 0 : ref.recommended_collection) !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
                    containerProps: {
                        flexDirection: "column",
                        gridGap: esm.spacing.XS.rem
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubsectionHeader/* default */.Z, {
                            children: "The idea is part of this collection:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionInHeader/* default */.Z, {
                            collection: source.seo.recommended_collection,
                            topic: (ref14 = (ref1 = source.ideas[0].hashtags) === null || ref1 === void 0 ? void 0 : ref1[0]) !== null && ref14 !== void 0 ? ref14 : "",
                            mb: global/* SECTION_GAP_REM */.hM
                        })
                    ]
                }) : null,
                ((ref2 = source.seo) === null || ref2 === void 0 ? void 0 : ref2.similar_collections) !== undefined && source.seo.similar_collections.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.medium.bold), {
                            color: esm.color[colorMode].text
                        }), isMobileView ? {
                            px: 16
                        } : {}), {
                            children: "Related collections"
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCollectionCarousel/* default */.Z, {
                            collections: (ref3 = source.seo.similar_collections) === null || ref3 === void 0 ? void 0 : ref3.slice(0, 4),
                            justifyContent: "flex-start",
                            mt: esm.spacing.M.rem,
                            pl: esm.spacing.M.rem
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SimilarIdeasList, (0,_object_spread/* default */.Z)({
                    similarIdeas: similarIdeas,
                    originalIdeaTitle: (_title = source.ideas[0].title) !== null && _title !== void 0 ? _title : source.ideas[0].authorName
                }, isMobileView ? {
                    px: 16
                } : {}))
            ]
        })),
        isFullscreen: isMobileView ? true : false
    };
    var ref15;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SourceProvider/* default */.Z, {
        source: source,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceSplashscreenBackground/* default */.Z, {
                zIndex: -1,
                themeColor: source.imageColor
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
                pageMetadata: pageMetadata,
                sections: sectionBefore ? [
                    sectionBefore,
                    sourceIdeasSection,
                    similarIdeasSection
                ] : [
                    sourceIdeasSection,
                    similarIdeasSection
                ],
                breadcrumbs: !!((ref4 = source.ideas[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.hashtags) === null || ref5 === void 0 ? void 0 : ref5.length) ? [
                    {
                        title: "Home",
                        link: "/"
                    },
                    {
                        title: (ref15 = (ref8 = metatopics_constants/* UNSORTED_TOPICS */.Ay[(ref6 = source.ideas[0]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.hashtags) === null || ref7 === void 0 ? void 0 : ref7[0]]) === null || ref8 === void 0 ? void 0 : ref8.title) !== null && ref15 !== void 0 ? ref15 : (ref9 = source.ideas[0]) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.hashtags) === null || ref10 === void 0 ? void 0 : ref10[0],
                        link: "/topic/" + ((ref11 = source.ideas[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.hashtags) === null || ref12 === void 0 ? void 0 : ref12[0])
                    },
                    {
                        title: source.title,
                        link: "/article/".concat(source.id, "/").concat((0,global/* slugify */.lV)(source.title))
                    },
                    {
                        title: !!((ref13 = firstIdea.title) === null || ref13 === void 0 ? void 0 : ref13.length) ? firstIdea.title : firstIdea.authorName ? "Quote by " + firstIdea.authorName : "Untitled Idea",
                        link: "/idea/".concat(firstIdea.id, "/").concat((0,global/* slugify */.lV)(firstIdea.title, firstIdea.content))
                    }, 
                ] : undefined,
                isShortProAd: true,
                showFooterPrices: false
            })
        ]
    });
};
/* harmony default export */ var source_IdeaPage = (IdeaPage);

// EXTERNAL MODULE: ./src/utils/metadata.utils.ts
var metadata_utils = __webpack_require__(83337);
// EXTERNAL MODULE: ./src/utils/normalizers/source.ts + 1 modules
var normalizers_source = __webpack_require__(27079);
;// CONCATENATED MODULE: ./pages/idea/[id]/[slug].tsx









var IdeaDynamicPage = function(param) {
    var insight = param.insight, similarIdeasApiResponse = param.similarIdeasApiResponse;
    // Page accessed NSI-only
    (0,react.useEffect)(function() {
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.consumption.viewIdea */.z.consumption.viewIdea,
            properties: {
                ideaId: insight.id,
                title: insight.title
            },
            platforms: [
                "amplitude"
            ]
        });
    }, [
        insight.id
    ]);
    var normalizedIdea = (0,normalizers_source/* normalizeIdea */.NA)(insight);
    var source = normalizedIdea.source;
    var ref;
    var ideas = [
        normalizedIdea, 
    ].concat((0,_to_consumable_array/* default */.Z)(((ref = source === null || source === void 0 ? void 0 : source.ideas) !== null && ref !== void 0 ? ref : []).filter(function(ideaFromMap) {
        return ideaFromMap.id !== normalizedIdea.id;
    })));
    if (!source) {
        // This should never happen
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(source_IdeaPage, {
        source: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, source), {
            ideas: ideas
        }),
        similarIdeas: similarIdeasApiResponse === null || similarIdeasApiResponse === void 0 ? void 0 : similarIdeasApiResponse.objects.map(function(similarIdea) {
            return (0,normalizers_source/* normalizeIdea */.NA)(similarIdea);
        }),
        pageMetadata: (0,metadata_utils/* getIdeaPageMetadata */.$t)({
            insight: insight
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (IdeaDynamicPage);


/***/ }),

/***/ 35905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "MENU_OPTIONS": function() { return /* binding */ MENU_OPTIONS; },
  "OWNER_OPTIONS": function() { return /* binding */ OWNER_OPTIONS; },
  "default": function() { return /* binding */ search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/source/source-collapsed/SourceCollapsed.tsx + 2 modules
var SourceCollapsed = __webpack_require__(85611);
// EXTERNAL MODULE: ./src/components/source/source-preview/SourcePreview.tsx + 2 modules
var SourcePreview = __webpack_require__(34549);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/chips/Chip.tsx
var Chip = __webpack_require__(34001);
// EXTERNAL MODULE: ./src/utils/StringUtils.tsx
var StringUtils = __webpack_require__(94030);
;// CONCATENATED MODULE: ./src/page-components/search/components/HashtagSearchedResultMobile.tsx







var HashtagSearchedResultDesktop = function(param) {
    var searchedHashtag = param.searchedHashtag;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var _sources;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDir: "column",
        align: "flex-start",
        mb: global/* BLOCK_WIDTH_REM */.sC,
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                alignItems: "center",
                gridGap: esm.spacing.M.rem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip/* default */.Z, {
                        content: "#" + searchedHashtag.name,
                        href: "topic/".concat(searchedHashtag.name),
                        m: "0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, {
                        fontSize: "0.8em",
                        color: esm.color[colorMode].textDisabled,
                        children: [
                            (0,global/* numberFormatter */.V2)(searchedHashtag.totalIdeas),
                            " ",
                            (0,StringUtils/* getSingularOrPlural */.Lo)(searchedHashtag.totalIdeas, "idea", "ideas")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                mt: global/* GAP_SIZE_REM */.L3,
                gridGap: global/* GAP_SIZE_REM */.L3,
                width: "100%",
                overflow: {
                    base: "scroll",
                    md: "hidden"
                },
                children: ((_sources = searchedHashtag.sources) !== null && _sources !== void 0 ? _sources : []).slice(0, 4).map(function(source) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                        size: "small",
                        source: source
                    }, source.id);
                })
            })
        ]
    });
};
/* harmony default export */ var HashtagSearchedResultMobile = (HashtagSearchedResultDesktop);

// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/components/social/ProfilePicture.tsx
var ProfilePicture = __webpack_require__(7877);
// EXTERNAL MODULE: ./src/components/buttons/FollowUserButton.tsx + 1 modules
var FollowUserButton = __webpack_require__(97360);
;// CONCATENATED MODULE: ./src/page-components/search/components/UserInfo.tsx








var UserInfo = function(param) {
    var user = param.user, index = param.index;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var profile = (0,useProfile/* default */.Z)().profile;
    var _bio;
    var bioFragments = (0,react.useMemo)(function() {
        return (0,StringUtils/* fragmentTextWithEmojis */.CO)((_bio = user.bio) !== null && _bio !== void 0 ? _bio : "");
    }, [
        user
    ]);
    if (!user) return null;
    var _photo;
    var displayUser = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        _focus: undefined,
        _active: undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfilePicture/* default */.Z, {
                m: esm.spacing.toRem(2),
                photo: (_photo = user.photo) !== null && _photo !== void 0 ? _photo : "",
                size: "l",
                imageBlurhash: user.photo_blurhash
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                ml: "8px",
                flexDir: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        fontSize: "16px",
                        lineHeight: "19px",
                        fontWeight: "bold",
                        color: esm.color[colorMode].primary,
                        _hover: {
                            textDecoration: "underline"
                        },
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: "@" + user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                        color: esm.color[colorMode].textSecondary,
                        textOverflow: "ellipsis",
                        noOfLines: 1,
                        children: !!user.firstName || !!user.lastName ? "".concat(user.firstName, " ").concat(user.lastName) : user.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        textAlign: "center",
                        w: "100%",
                        children: bioFragments.map(function(fragment) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                size: "s",
                                color: esm.color[colorMode].textDisabled,
                                textOverflow: "ellipsis",
                                noOfLines: 1,
                                children: fragment
                            }, fragment);
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
        bgColor: esm.color[colorMode].top,
        p: esm.spacing.toRem(16),
        borderRadius: esm.spacing.toRem(20),
        mb: esm.spacing.toRem(12),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            justifyContent: "space-between",
            alignItems: "start",
            _focus: undefined,
            _active: undefined,
            wordBreak: "break-all",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                    href: "/u/".concat(user.username),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                        w: "100%",
                        _focus: undefined,
                        _active: undefined,
                        _hover: undefined,
                        children: displayUser
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowUserButton/* default */.Z, {
                    display: (profile === null || profile === void 0 ? void 0 : profile.id) === user.id ? "none" : "inline-flex",
                    userId: user.id,
                    size: "sm",
                    px: esm.spacing.toRem(12),
                    py: esm.spacing.toRem(6)
                })
            ]
        })
    }, index);
};
/* harmony default export */ var components_UserInfo = (UserInfo);

;// CONCATENATED MODULE: ./src/page-components/search/SearchPage.tsx









var SearchPageMobile = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9283).then(__webpack_require__.bind(__webpack_require__, 19283));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19283)
            ];
        }
    }
});
var SearchPageDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(296), __webpack_require__.e(9891), __webpack_require__.e(9834), __webpack_require__.e(2853), __webpack_require__.e(1425), __webpack_require__.e(7436)]).then(__webpack_require__.bind(__webpack_require__, 16171));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16171)
            ];
        }
    }
});
SearchPageDesktop.displayName = "SearchPageDesktop";
SearchPageMobile.displayName = "SearchPageMobile";
var SearchPage = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    var isMobileView = (0,esm.useIsMobileView)();
    /**
   * Render the search results
   * @param feed The results to be rendered
   * @param isFetching Whether or not we are currently fetching more results
   * @param searchType What we are searching for
   * @param errorMessage A component to be shown if no results were found
   */ var renderFeed = (0,react.useCallback)(function(feed, isFetching, searchType, errorMessage) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(esm.Box, {
            children: !isFetching && (!feed || feed.length === 0) ? errorMessage : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                children: [
                    searchType === "article" && feed.map(function(source) {
                        if ((0,global/* isSourceEmpty */.dq)(source)) return null;
                        if (searchType === "article") {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourceCollapsed/* default */.Z, {
                                    source: source,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, "articleCard$".concat(source.id));
                        }
                        return null;
                    }),
                    searchType === "block" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        flexDir: "column",
                        width: "100%",
                        alignItems: "center",
                        children: feed === null || feed === void 0 ? void 0 : feed.map(function(idea) {
                            var source = idea.source;
                            if (!source || (0,global/* isSourceEmpty */.dq)(source)) return null;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SourcePreview/* default */.Z, {
                                    source: source,
                                    ideaId: idea.id,
                                    mb: esm.spacing.XXXL.rem
                                })
                            }, source.id);
                        })
                    }),
                    searchType === "user" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(user, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserInfo, {
                                user: user,
                                index: index
                            }, user.id);
                        })
                    }),
                    searchType === "hashtag" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                        px: {
                            base: "1rem",
                            lg: 0
                        },
                        children: feed.map(function(searchedHashtag, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HashtagSearchedResultMobile, {
                                searchedHashtag: searchedHashtag
                            }, "SearchHashtagSection-".concat(searchedHashtag.name, "-").concat(index));
                        })
                    })
                ]
            })
        });
    }, []);
    return isMobileView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageMobile, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageDesktop, {
        initialSearchType: initialSearchType,
        renderFeed: renderFeed,
        initialApiData: initialApiData
    });
};
/* harmony default export */ var search_SearchPage = (SearchPage);

;// CONCATENATED MODULE: ./pages/search.tsx



var MENU_OPTIONS = [
    {
        title: "Ideas",
        key: "block"
    },
    {
        title: "People",
        key: "user"
    },
    {
        title: "Topics",
        key: "hashtag"
    },
    {
        title: "Sources",
        key: "article"
    }, 
];
var OWNER_OPTIONS = [
    {
        title: "All",
        key: "all"
    },
    {
        title: "Own",
        key: "own"
    }, 
];
var Search = function(param) {
    var initialApiData = param.initialApiData, initialSearchType = param.initialSearchType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_SearchPage, {
        initialApiData: initialApiData !== null && initialApiData !== void 0 ? initialApiData : undefined,
        initialSearchType: initialSearchType !== null && initialSearchType !== void 0 ? initialSearchType : undefined
    });
};
// export const getServerSideProps: GetServerSideProps<OwnProps> = async ctx => {
//   const { q, owner, tab } = ctx.query;
//   const { token } = cookie.parse(ctx.req.headers.cookie ?? '');
//   if (!q) {
//     return {
//       props: {
//         initialApiData: null,
//         initialSearchType: null,
//       },
//     };
//   }
//   //Get rid of the # in the query
//   let parsedSearchText = q as string;
//   if (parsedSearchText.includes('#')) {
//     parsedSearchText = replaceAll(parsedSearchText, '#', '');
//   }
//   //Get the search type based on the query param
//   const searchType =
//     MENU_OPTIONS.find(
//       option => option.title.toLowerCase() === (tab as SearchType),
//     )?.key ?? 'block';
//   const res = await search(
//     parsedSearchText,
//     searchType,
//     owner as 'all' | 'own',
//     token,
//   );
//   return {
//     props: {
//       initialApiData: res ?? null,
//       initialSearchType: searchType,
//     },
//   };
// };
/* harmony default export */ var search = (Search);


/***/ }),

/***/ 81089:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ buttons_FollowUserButtonV2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/hooks/user/useIsUserFollowed.ts
var useIsUserFollowed = __webpack_require__(931);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/providers/hooks/useActivity.ts
var useActivity = __webpack_require__(8565);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/providers/hooks/useNsi.ts
var useNsi = __webpack_require__(9182);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(14531);
// EXTERNAL MODULE: ./src/utils/strings/commonStrings.ts
var commonStrings = __webpack_require__(51599);
;// CONCATENATED MODULE: ./src/components/buttons/FollowDummyButtonV2.tsx








var FollowDummyButtonV2 = function(_param) {
    var isDisabled = _param.isDisabled, isFollowed = _param.isFollowed, onClickHandler = _param.onClickHandler, size = _param.size, buttonBackgroundColor = _param.buttonBackgroundColor, title = _param.title, id = _param.id, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isDisabled",
        "isFollowed",
        "onClickHandler",
        "size",
        "buttonBackgroundColor",
        "title",
        "id"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var followText = (0,react.useMemo)(function() {
        if (title) {
            return title;
        }
        return isFollowed ? commonStrings/* default.following.toUpperCase */.Z.following.toUpperCase() : commonStrings/* default.follow.toUpperCase */.Z.follow.toUpperCase();
    }, [
        isFollowed,
        title
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.SecondaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        colorMode: colorMode,
        size: size,
        bgColor: buttonBackgroundColor,
        borderColor: esm.color[colorMode].text,
        _active: undefined,
        onClick: onClickHandler,
        disabled: isDisabled,
        id: id,
        shadow: undefined,
        transition: "all ".concat(constants/* TRANSITION_TIME */.aV, "s ease-in-out"),
        color: esm.color[colorMode].text,
        _hover: {
            backgroundColor: esm.color[colorMode].text,
            color: esm.color[colorMode].textInverted
        }
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
            type: "bold",
            w: "max-content",
            size: size === "lg" ? "l" : "s",
            id: id ? "".concat(id, "-text") : undefined,
            children: followText
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/buttons/FollowUserButtonV2.tsx












var FollowUserButtonV2 = function(_param) {
    var userId = _param.userId, size = _param.size, title = _param.title, onFollowSuccess = _param.onFollowSuccess, props = (0,_object_without_properties/* default */.Z)(_param, [
        "userId",
        "size",
        "title",
        "onFollowSuccess"
    ]);
    var profile = (0,useProfile/* default */.Z)().profile;
    var toggleFollowUser = (0,useActivity/* default */.Z)().toggleFollowUser;
    var nsiDispatch = (0,useNsi/* default */.Z)().nsiDispatch;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var ownId = profile === null || profile === void 0 ? void 0 : profile.id;
    var ref = (0,useIsUserFollowed/* useIsUserFollowed */.g)(userId), isFollowed = ref.isUserFollowed;
    var ref1 = (0,react.useState)(false), isDisabled = ref1[0], setIsDisabled = ref1[1];
    var onRequestFinish = function() {
        setIsDisabled(false);
    };
    var onClickHandler = function(e) {
        e.stopPropagation();
        e.preventDefault();
        setIsDisabled(true);
        if (!isLoggedIn) {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-in"
                }
            });
            setIsDisabled(false);
            return;
        }
        if (isFollowed) {
            analytics/* Analytics.logEvent */.c.logEvent({
                eventName: analytics/* Events.social.unfollowUser */.z.social.unfollowUser,
                properties: {
                    targetProfileId: userId
                },
                platforms: [
                    "amplitude"
                ]
            });
            onFollowSuccess === null || onFollowSuccess === void 0 ? void 0 : onFollowSuccess(true);
        } else {
            analytics/* Analytics.logEvent */.c.logEvent({
                eventName: analytics/* Events.social.followUser */.z.social.followUser,
                properties: {
                    targetProfileId: userId
                },
                platforms: [
                    "amplitude"
                ]
            });
            onFollowSuccess === null || onFollowSuccess === void 0 ? void 0 : onFollowSuccess(false);
        }
        toggleFollowUser({
            userId: userId,
            isFollowed: isFollowed,
            onFinish: onRequestFinish
        });
    };
    if (ownId === userId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FollowDummyButtonV2, (0,_object_spread/* default */.Z)({
        isDisabled: isDisabled,
        size: size,
        isFollowed: isFollowed,
        onClickHandler: function(e) {
            return onClickHandler(e);
        },
        ml: {
            lg: esm.spacing.S.rem
        },
        buttonBackgroundColor: esm.color.transparent,
        title: title,
        id: "follow-user-button-".concat(userId)
    }, props));
};
/* harmony default export */ var buttons_FollowUserButtonV2 = (FollowUserButtonV2);


/***/ }),

/***/ 13318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_social_ProfileCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24839);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51599);
/* harmony import */ var _components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17005);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63069);










var CuratorSection = function(_param) {
    var user = _param.user, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "user"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                pb: utils_global__WEBPACK_IMPORTED_MODULE_6__/* .GAP_SIZE_REM */ .L3,
                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].metacontent.curatorSectionHeader */ .Z.metacontent.curatorSectionHeader
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.bold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                type: "bold",
                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].metacontent.curatorSectionHeader */ .Z.metacontent.curatorSectionHeader
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_social_ProfileCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                user: user,
                size: "lg"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CuratorSection);


/***/ }),

/***/ 24839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var _buttons_FollowUserButtonV2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81089);
/* harmony import */ var _cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46039);
/* harmony import */ var _navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);
/* harmony import */ var _ProfilePicture__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7877);











var ProfileCard = function(_param) {
    var user = _param.user, size = _param.size, withBackground = _param.withBackground, maxNoOfLinesBio = _param.maxNoOfLinesBio, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "user",
        "size",
        "withBackground",
        "maxNoOfLinesBio"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var _photo;
    var renderProfilePicture = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            href: "/u/".concat(user.username),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
                _hover: undefined,
                _active: undefined,
                _focus: undefined,
                onClick: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .onLinkClick */ .nt,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProfilePicture__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    boxSize: "4rem",
                    photo: (_photo = user.photo) !== null && _photo !== void 0 ? _photo : "",
                    size: "xl",
                    altTag: user.username,
                    imageBlurhash: user.photo_blurhash,
                    p: "0",
                    pr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                    mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem
                })
            })
        });
    };
    var userInfo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        href: "/u/".concat(user.username),
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            _hover: undefined,
            _active: undefined,
            _focus: undefined,
            onClick: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .onLinkClick */ .nt,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text
                }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.small.bold), {
                    children: user.firstName + " " + user.lastName
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                    mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem,
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                    opacity: 0.4
                }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.small), {
                    children: "@" + user.username
                }))
            ]
        })
    });
    var userBio = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
        noOfLines: maxNoOfLinesBio
    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.small), {
        children: user.bio
    }));
    if (size === "lg") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "100%",
            flexDirection: "column",
            bgColor: withBackground ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface : "unset",
            hasHoverEffect: !!withBackground,
            py: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem
        }, props), {
            children: [
                renderProfilePicture(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                            flexDirection: "column",
                            children: userInfo
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons_FollowUserButtonV2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            userId: user.id,
                            height: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .SQUARE_WIDTH_REM */ .wY,
                            width: "8rem"
                        })
                    ]
                }),
                userBio
            ]
        }));
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cards_BaseCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            width: "100%",
            bgColor: withBackground ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface : "unset",
            hasHoverEffect: !!withBackground
        }, props), {
            children: [
                renderProfilePicture(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexDir: "column",
                    children: [
                        userInfo,
                        userBio
                    ]
                })
            ]
        }));
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileCard);


/***/ }),

/***/ 84803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91260);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50752);








 // Use it instead of own useRouter for fixing scroll problems

var COLLECTION_IMAGE_SIZE = {
    WIDTH: 140,
    HEIGHT: 175,
    BORDER_RADIUS: 8
};
var FALLBACK_SKILLS = [
    "How to prioritize tasks effectively",
    "How to minimize distractions",
    "How to optimize your work environment",
    "How to use technology to your advantage",
    "How to delegate tasks efficiently", 
];
var CollectionInHeader = function(_param) {
    var collection = _param.collection, topic = _param.topic, _showStartJourneyButton = _param.showStartJourneyButton, showStartJourneyButton = _showStartJourneyButton === void 0 ? false : _showStartJourneyButton, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "collection",
        "topic",
        "showStartJourneyButton"
    ]);
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var collectionSlug = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,utils_global__WEBPACK_IMPORTED_MODULE_3__/* .slugify */ .lV)(collection.name);
    }, [
        collection.name
    ]);
    var collectionPageRoute = "/collection/".concat(collection.id, "/").concat(collectionSlug);
    var finalSkills = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return collection.skills !== undefined ? collection.skills : FALLBACK_SKILLS;
    }, [
        collection.skills
    ]);
    var renderSkill = function(param) {
        var skill = param.skill, index = param.index;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
            flexDirection: "row",
            alignItems: "flex-start",
            gridColumnGap: 4,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.CheckFillSvg, {
                    color: "green",
                    boxSize: isMobileView ? "24px" : "26px"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular : deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                    flex: 1,
                    children: skill
                }))
            ]
        }, "skill-".concat(index));
    };
    var collectionImage = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        wrapperStyle: {
            width: COLLECTION_IMAGE_SIZE.WIDTH,
            height: COLLECTION_IMAGE_SIZE.HEIGHT,
            borderRadius: COLLECTION_IMAGE_SIZE.BORDER_RADIUS,
            cursor: "pointer"
        },
        imageUrl: collection.image,
        blurhash: collection.image_blurhash,
        alt: "".concat(collection.name),
        priority: false,
        onClick: function() {
            router.push(collectionPageRoute);
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        bgColor: "".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].top, "66"),
        flexDirection: isMobileView ? "column" : "row",
        p: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE */ .DG,
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE */ .DG,
        borderRadius: 16,
        alignItems: "flex-end"
    }, props), {
        children: [
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                width: "100%",
                justifyContent: "center",
                children: collectionImage
            }) : collectionImage,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flex: 1,
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                        children: "Learn more about ".concat(topic, " with this collection")
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        href: collectionPageRoute,
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Link, {
                            _focus: undefined,
                            _hover: {
                                textDecoration: "underline"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.medium.bold), {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                                children: collection.name
                            }))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        flexDirection: "column",
                        gridRowGap: 8,
                        mt: 16
                    }, isMobileView ? {
                        width: "100%"
                    } : {}), {
                        children: finalSkills.slice(0, 3).map(function(skill, index) {
                            return renderSkill({
                                skill: skill,
                                index: index
                            });
                        })
                    }))
                ]
            }),
            showStartJourneyButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton, {
                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.spacing.toRem(48),
                width: {
                    base: "100%",
                    md: "auto"
                },
                onClick: function() {
                    return router.push(collectionPageRoute);
                },
                children: "Start Journey"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionInHeader);


/***/ }),

/***/ 24027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79139);
/* harmony import */ var providers_hooks_useSource__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93361);
/* harmony import */ var providers_reads_autoincrement_IntersectionObserverProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7315);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var src_components_idea_card_IdeaCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63848);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63069);
/* harmony import */ var utils_source_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15959);
/* harmony import */ var _SourceNSIArticleGradient__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(94120);














var NSI_IDEA_SECTION_HEIGHT_UNDER_3 = 1500;
var NSI_IDEA_SECTION_HEIGHT_OVER_3 = 2000;
var SourceCardIdeas = function(_param) {
    var _isInteractive = _param.isInteractive, isInteractive = _isInteractive === void 0 ? true : _isInteractive, _isNsiBlocked = _param.isNsiBlocked, isNsiBlocked = _isNsiBlocked === void 0 ? true : _isNsiBlocked, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_param, [
        "isInteractive",
        "isNsiBlocked"
    ]);
    var ref, ref1;
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isLoggedIn;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var ref2 = (0,providers_hooks_useSource__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), source = ref2.source, sourceDispatch = ref2.sourceDispatch;
    var setInsights = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(providers_reads_autoincrement_IntersectionObserverProvider__WEBPACK_IMPORTED_MODULE_5__.IntersectionObserverContext).setInsights;
    // Register ideas to the intersection observer to be eligible for auto-reading
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (source) {
            setInsights(source.ideas);
        }
    }, [
        source === null || source === void 0 ? void 0 : source.ideas
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var onToggleSaveIdea = function(param) {
        var ideaId = param.ideaId, isSaved = param.isSaved;
        sourceDispatch({
            type: "toggle-save-idea",
            payload: {
                isSaved: isSaved,
                ideaId: ideaId
            }
        });
    };
    var isIdeaBlockedNsi = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function(index) {
        if (source && source.ideas.length <= 2) {
            return index >= 1;
        } else return index >= 2;
    }, [
        source === null || source === void 0 ? void 0 : source.ideas.length,
        router.asPath
    ]);
    if (!source) return null;
    var ref3;
    var mainLayoutSectionHeight = isLoggedIn || !isNsiBlocked ? "unset" : ((ref3 = source === null || source === void 0 ? void 0 : (ref = source.ideas) === null || ref === void 0 ? void 0 : ref.length) !== null && ref3 !== void 0 ? ref3 : 0) < 3 ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(NSI_IDEA_SECTION_HEIGHT_UNDER_3) : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(NSI_IDEA_SECTION_HEIGHT_OVER_3);
    var renderIdeaCard = function(idea, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            id: "idea_".concat(idea.id),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_idea_card_IdeaCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                border:  true && window.location.hash === "#idea_".concat(idea.id) ? "4px solid ".concat(source.imageColor) : "none",
                ideaData: {
                    idea: idea,
                    source: source
                },
                preloadImage: true,
                w: {
                    base: "100%",
                    md: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(6)
                },
                onIdeaStashed: function() {
                    return onToggleSaveIdea({
                        ideaId: idea.id,
                        isSaved: true
                    });
                },
                onIdeaUnstashed: function() {
                    return onToggleSaveIdea({
                        ideaId: idea.id,
                        isSaved: false
                    });
                },
                transition: "all 0.2s cubic-bezier(.43,.22,.05,.99)",
                zIndex: 1,
                minH: "auto",
                isNotInteractable: !isInteractive,
                filter: isIdeaBlockedNsi(index) && !isLoggedIn && isNsiBlocked ? "blur(4px)" : "",
                userSelect: isIdeaBlockedNsi(index) && !isLoggedIn && isNsiBlocked ? "none" : "text"
            })
        });
    };
    var _ideaCount;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        pos: "relative",
        maxHeight: mainLayoutSectionHeight,
        overflowY: "hidden",
        flexDirection: "column",
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_8__/* .GAP_SIZE_REM */ .L3,
        ml: {
            base: 0,
            lg: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(1)
        }
    }, props), {
        children: [
            !isLoggedIn && isNsiBlocked && ((_ideaCount = source.ideaCount) !== null && _ideaCount !== void 0 ? _ideaCount : 0) > 1 && router.pathname !== "/idea/[id]/[slug]" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SourceNSIArticleGradient__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                collection: (ref1 = source.seo) === null || ref1 === void 0 ? void 0 : ref1.recommended_collection,
                // We need this shift because we need to cover the 4px blur
                w: {
                    base: "100%",
                    md: "calc(".concat((0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(6), " + 8px)")
                },
                ml: {
                    base: 0,
                    md: -4
                },
                underlineColor: (0,utils_source_utils__WEBPACK_IMPORTED_MODULE_9__/* .getSourceThemeColor */ .Dv)(source.sourceType, colorMode)
            }),
            router.pathname === "/idea/[id]/[slug]" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: renderIdeaCard(source.ideas[0], 0)
            }) : source.ideas.sort(function(a, b) {
                return a.order - b.order;
            }).map(function(idea, index) {
                return renderIdeaCard(idea, index);
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceCardIdeas);


/***/ }),

/***/ 65821:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var providers_hooks_useActivity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8565);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79139);
/* harmony import */ var providers_hooks_useNsiActivity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7964);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63069);







var SourceCardVerticalProgress = function(param) {
    var source = param.source;
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isLoggedIn;
    var activity = (0,providers_hooks_useActivity__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().activity;
    var ref = (0,providers_hooks_useNsiActivity__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), nsiReads = ref.reads;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isIdeaRead = function(ideaId) {
        var ref;
        return (activity === null || activity === void 0 ? void 0 : (ref = activity.reads) === null || ref === void 0 ? void 0 : ref[ideaId]) || nsiReads.sessionReads.has(ideaId);
    };
    if (!source) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        w: (0,utils_global__WEBPACK_IMPORTED_MODULE_6__/* .getRemWidthFromColumns */ ._P)(1),
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
        flexDirection: "column",
        mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
        children: (isLoggedIn ? source.ideas : source.ideas.slice(0, 4)).map(function(idea, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                w: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(200 / (isLoggedIn ? source.ideas : source.ideas.slice(0, 4)).length),
                borderRadius: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(2),
                backgroundColor: isIdeaRead(idea.id) ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textDisabled,
                transition: "all 0.6s cubic-bezier(.43,.22,.05,.99)",
                opacity: isIdeaRead(idea.id) ? 0.8 : 0.4
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceCardVerticalProgress);


/***/ }),

/***/ 94120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_page_components_landing_components_v2_LandingStartTrialSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90182);







var SourceNSIArticleGradient = function(_param) {
    var collection = _param.collection, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "collection"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    // const router = useRouter();
    // We make the gradientFooterRef absolute after scrolling past a point.
    var gradientFooterRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
    // const collectionSlug = React.useMemo(() => {
    //   if (collection === undefined) {
    //     return '';
    //   }
    //   return slugify(collection.name);
    // }, [collection]);
    // const collectionPageRoute = `/collection/${collection?.id}/${collectionSlug}`;
    // const minutesToRead = React.useMemo(() => {
    //   if (collection?.time_to_read !== undefined) {
    //     return formatSecondsToNearestMinute(collection.time_to_read);
    //   }
    //   return undefined;
    // }, [collection]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
        position: "absolute",
        ref: gradientFooterRef,
        height: "100%",
        width: "100%",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            // position={gradientFooterPosition === 'fixed' ? 'fixed' : 'absolute'}
            position: "absolute",
            zIndex: 5,
            bottom: 0,
            left: 0,
            top: "unset",
            right: 0,
            width: "100%",
            height: {
                base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(480),
                md: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(600)
            },
            background: "linear-gradient(to top,  ".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background, " ").concat(isMobileView ? 75 : 60, "%,").concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.transparent, " 100%)"),
            flexDirection: "column",
            justifyContent: collection === undefined ? "flex-end" : "center",
            alignItems: "center",
            pb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8)
        }, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                px: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16),
                flexDirection: "column",
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_landing_components_v2_LandingStartTrialSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    isCentered: true
                })
            })
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceNSIArticleGradient);


/***/ }),

/***/ 1206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14531);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);








var SourceSplashscreenBackground = function(_param) {
    var themeColor = _param.themeColor, customGradient = _param.customGradient, customHeight = _param.customHeight, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "themeColor",
        "customGradient",
        "customHeight"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        position: "absolute",
        height: customHeight !== null && customHeight !== void 0 ? customHeight : "100vh",
        width: "100%",
        top: 0,
        left: 0,
        overflow: "hidden"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                position: "absolute",
                height: "100%",
                width: "100%",
                top: 0,
                left: 0,
                background: customGradient !== null && customGradient !== void 0 ? customGradient : (0,utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .createGradient */ .FK)((0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .getTintHex */ .As)({
                    ogColor: themeColor !== null && themeColor !== void 0 ? themeColor : "",
                    opacity: 0.7,
                    colorScheme: colorMode
                }), 90)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                position: "absolute",
                height: "100%",
                width: "100%",
                top: 0,
                left: 0,
                background: (0,utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .createGradient */ .FK)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background, 270)
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SourceSplashscreenBackground);


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ObserverMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = ObserverMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    ObserverMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options) {
  if (options === void 0) {
    options = {};
  }

  if (!element) return function () {}; // An observer with the same options can be reused, so lets use this fact

  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      ObserverMap["delete"](id);
    }
  };
}

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    });
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        tag = _this$props2.tag,
        props = _objectWithoutPropertiesLoose(_this$props2, ["children", "as", "tag", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView"]);

    return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(as || tag || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView;

  var unobserve = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _React$useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      });
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (InView)));

//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 45363:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
__webpack_unused_export__ = ({ value: true });
exports.h6 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;
var json_ld_1 = __webpack_require__(82342);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.helmetJsonLdProp; } });
__webpack_unused_export__ = ({ enumerable: true, get: function () { return json_ld_1.JsonLd; } });
Object.defineProperty(exports, "h6", ({ enumerable: true, get: function () { return json_ld_1.jsonLdScriptProps; } }));


/***/ }),

/***/ 82342:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.helmetJsonLdProp = exports.jsonLdScriptProps = exports.JsonLd = void 0;
const React = __webpack_require__(67294);
function JsonLd(props) {
    return React.createElement("script", Object.assign({}, jsonLdScriptProps(props.item, props)));
}
exports.JsonLd = JsonLd;
function jsonLdScriptProps(item, options = {}) {
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, safeJsonLdReplacer, options.space),
        },
    };
}
exports.jsonLdScriptProps = jsonLdScriptProps;
function helmetJsonLdProp(item, options = {}) {
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, safeJsonLdReplacer, options.space),
    };
}
exports.helmetJsonLdProp = helmetJsonLdProp;
const ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;",
});
const ESCAPE_REGEX = new RegExp(`[${Object.keys(ESCAPE_ENTITIES).join("")}]`, "g");
const ESCAPE_REPLACER = (t) => ESCAPE_ENTITIES[t];
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */
const safeJsonLdReplacer = (() => {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return (_, value) => {
        switch (typeof value) {
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default: {
                // We shouldn't expect other types.
                isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
            }
        }
    };
})();
// Utility: Assert never
function isNever(_) { }


/***/ }),

/***/ 4022:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldGet; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_extract_field_descriptor.mjs
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_apply_descriptor_get.mjs
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_get.mjs



function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}


/***/ }),

/***/ 70222:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _classPrivateFieldInit; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_check_private_redeclaration.mjs
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_private_field_init.mjs


function _classPrivateFieldInit(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}


/***/ }),

/***/ 40872:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}


/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,7229,9000,9891,9834,5611,2853,3244,9774,2888,179], function() { return __webpack_exec__(65539); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);